import { create } from 'zustand';

export const useSearchStringStore = create(set => ({
  searchString: '',
  setSearchString: searchString => {
    set({ searchString });
  },
}));
